module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-progress"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "order-progress-element",
    class: _vm.step == 1 ? 'active-element' : 'inactive-element'
  }, [_c('h2', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Punkt podjęcia")])]), _vm._v(" "), _c('div', {
    staticClass: "order-progress-element",
    class: _vm.step == 2 ? 'active-element' : 'inactive-element'
  }, [_c('h2', [_vm._v("2")]), _vm._v(" "), _c('p', [_vm._v("Adres realizacji")])]), _vm._v(" "), _c('div', {
    staticClass: "order-progress-element",
    class: _vm.step == 3 ? 'active-element' : 'inactive-element'
  }, [_c('h2', [_vm._v("3")]), _vm._v(" "), _c('p', [_vm._v("Numery zamówień")])]), _vm._v(" "), _c('div', {
    staticClass: "order-progress-element",
    class: _vm.step == 4 ? 'active-element' : 'inactive-element'
  }, [_c('h2', [_vm._v("4")]), _vm._v(" "), _c('p', [_vm._v("Termin dostawy")])]), _vm._v(" "), _c('div', {
    staticClass: "order-progress-element",
    class: _vm.step == 5 || _vm.step == 6 ? 'active-element' : 'inactive-element'
  }, [_c('h2', [_vm._v("5")]), _vm._v(" "), _c('p', [_vm._v("Podsumowanie")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-687c5a77","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StepBar.vue
// module id = 258
// module chunks = 1